/* O foco continua nativo; só a indicação visual acompanha mouse/toque ou teclado. */
(() => {
  const root = document.documentElement;
  const pointerOptions = { capture: true, passive: true };
  const navigationKeys = new Set(['Tab', 'Enter', ' ', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Home', 'End', 'PageUp', 'PageDown']);
  const usePointer = () => { root.dataset.ohliInput = 'pointer'; };

  if ('PointerEvent' in window) {
    document.addEventListener('pointerdown', usePointer, pointerOptions);
  } else {
    document.addEventListener('mousedown', usePointer, pointerOptions);
    document.addEventListener('touchstart', usePointer, pointerOptions);
  }

  document.addEventListener('keydown', (event) => {
    // Esc fecha o modal sem mudar a modalidade que abriu o controle.
    if (event.metaKey || event.altKey || event.ctrlKey || !navigationKeys.has(event.key)) return;
    root.dataset.ohliInput = 'keyboard';
  }, true);

  // Ativação por tecnologia assistiva também mantém a indicação de foco.
  document.addEventListener('click', (event) => {
    if (!event.isTrusted) return; // .click() de componentes não é navegação por teclado.
    if (event.pointerType || event.sourceCapabilities?.firesTouchEvents || event.detail > 0) usePointer();
    else root.dataset.ohliInput = 'keyboard';
  }, true);
})();
